/**
* hoverIntent r5 // 2007.03.27 // jQuery 1.1.2+
* <http://cherne.net/brian/resources/jquery.hoverIntent.html>
* 
* @param  f  onMouseOver function || An object with configuration options
* @param  g  onMouseOut function  || Nothing (use configuration options object)
* @author    Brian Cherne <brian@cherne.net>
*/
(function($){$.fn.hoverIntent=function(f,g){var cfg={sensitivity:7,interval:100,timeout:0};cfg=$.extend(cfg,g?{over:f,out:g}:f);var cX,cY,pX,pY;var track=function(ev){cX=ev.pageX;cY=ev.pageY;};var compare=function(ev,ob){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);if((Math.abs(pX-cX)+Math.abs(pY-cY))<cfg.sensitivity){$(ob).unbind("mousemove",track);ob.hoverIntent_s=1;return cfg.over.apply(ob,[ev]);}else{pX=cX;pY=cY;ob.hoverIntent_t=setTimeout(function(){compare(ev,ob);},cfg.interval);}};var delay=function(ev,ob){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);ob.hoverIntent_s=0;return cfg.out.apply(ob,[ev]);};var handleHover=function(e){var p=(e.type=="mouseover"?e.fromElement:e.toElement)||e.relatedTarget;while(p&&p!=this){try{p=p.parentNode;}catch(e){p=this;}}if(p==this){return false;}var ev=jQuery.extend({},e);var ob=this;if(ob.hoverIntent_t){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);}if(e.type=="mouseover"){pX=ev.pageX;pY=ev.pageY;$(ob).bind("mousemove",track);if(ob.hoverIntent_s!=1){ob.hoverIntent_t=setTimeout(function(){compare(ev,ob);},cfg.interval);}}else{$(ob).unbind("mousemove",track);if(ob.hoverIntent_s==1){ob.hoverIntent_t=setTimeout(function(){delay(ev,ob);},cfg.timeout);}}};return this.mouseover(handleHover).mouseout(handleHover);};})(jQuery);

/* ---------------------------------------------------------------------------
 * resizePhotos plugin
 * by John Tajima
 * copyright 2010
 *
 * resizes and fades in nicely any photo.
 * 
 * Do *not* call in document ready, as some functionality requires window.ready
 * event.
 * ---------------------------------------------------------------------------
 */

(function($) {
   
   // plugin
   $.fn.resizePhotos = function(options) { 
     var opts = $.extend({}, $.fn.resizePhotos.defaults, options);
     logger(["calling resizePhotos", opts]);
     
     $(this).each(function(i,el){       
       logger(el);       
       resizeImage(el, opts.maxHeight, opts.maxWidth);
       $(el).fadeIn(opts.fadeIn);
       logger("done");
     });
     return this;
   };
   
   // defaults
   $.fn.resizePhotos.defaults = {
     timeout: 4000,
     fadeIn: 'fast',
     maxHeight: 750,
     maxWidth: 750
   };

   // private methods
})(jQuery);

function resizePhotos(selector, options) {
  var opts = $.extend({}, resizePhotos.defaults, options);

  $(selector).hide();
  $(window).load(function(){
    $(selector).resizePhotos(opts);
  });
};


/* helper functions */
function logger(msg) {
  var search = window.location.search;
  var debug_enabled = window['debug'] || search.match(/debug/);
  if (window.console && window.console.log && debug_enabled) {
    console.log(msg);
  }
};

/* resisze function */
function resizeImage(el, maxHeight, maxWidth) {
  var $el = $(el);
  if ($el.height() < maxHeight && $el.width() < maxWidth) {
    return; // orig is smaller than max - no need to resize
  }
  if ($el.height() == 0 || $el.width() == 0) {
    return;
  }
  
  var scale = Math.min(maxHeight/$el.height(),maxWidth/$el.width());
  new_h = scale * $el.height();
  new_w = scale * $el.width();
  $el.height(new_h).width(new_w);  
  logger("new size: H: " + new_h + " W: " + new_w + " ratio: " + scale);
};